import React from 'react'
import {Gradients, IconFont, Notification} from '@influxdata/clockface'
import {useNotify} from 'js/hooks'

export default ({flashType, message}) => {
  const [notify, {hide}] = useNotify('visible')

  switch (flashType) {
    case 'error':
      return (
        <Notification
          gradient={Gradients.DangerDark}
          icon={IconFont.AlertTriangle}
          onDismiss={hide}
          onTimeout={hide}
          visibly={notify}
        >
          {message}
        </Notification>
      )
    case 'warning':
      return (
        <Notification
          gradient={Gradients.Warning}
          icon={IconFont.AlertTriangle}
          onDismiss={hide}
          onTimeout={hide}
          visibly={notify}
        >
          {message}
        </Notification>
      )
    default:
      return (
        <Notification
          gradient={Gradients.Primary}
          icon={IconFont.Bell}
          onDismiss={hide}
          onTimeout={hide}
          visibly={notify}
        >
          {message}
        </Notification>
      )
  }
}
